<div class="register-component">
    <div #formContainer class="container mt-1">
        <h1 class="mb-4 form-label">{{ finalResources.formLabel }}</h1>
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">

            <div class="row mb-3">
                <div class="col-md-12">
                    <label for="fullName" class="form-label">
                        {{ finalResources.fullNameLabel }} <span class="text-danger">*</span>
                    </label>
                    <input id="fullName" formControlName="fullName" type="text" class="form-control"
                        [placeholder]="finalResources.fullNamePlaceHolder"
                        [ngClass]="{'is-invalid': registerForm.get('fullName')?.invalid && registerForm.get('fullName')?.touched}"
                        (input)="triggerValidation('fullName')" />

                    <div *ngIf="registerForm.get('fullName')?.touched && registerForm.get('fullName')?.invalid">
                        <small class="text-danger" *ngIf="registerForm.get('fullName')?.errors?.['required']">
                            {{ finalResources.fullNameRequiredErrMsg }}
                        </small>
                        <small class="text-danger" *ngIf="registerForm.get('fullName')?.errors?.['minlength']">
                            {{ finalResources.fullNameMinCharactersErrMsg }}
                        </small>
                        <small class="text-danger" *ngIf="registerForm.get('fullName')?.errors?.['maxlength']">
                            {{finalResources.fullNameMaxCharactersErrMsg}}
                        </small>
                        <small class="text-danger" *ngIf="registerForm.get('fullName')?.errors?.['pattern']">
                            {{finalResources.invalidFullNameErrMsg}}
                        </small>
                        <small class="text-danger" *ngIf="registerForm.get('fullName')?.errors?.['onlySpaces']">
                            {{ finalResources.invalidFullNameErrMsg}}
                        </small>
                    </div>
                </div>
            </div>

            <div class="row mb-3" *ngIf="allowMobile">
                <div class="col-md-12">
                    <label for="mobileNumber" class="form-label">
                        {{ finalResources.mobileNumberLabel }}
                    </label>
                    <input id="mobileNumber" formControlName="mobileNumber" type="text" class="form-control"
                        [placeholder]="finalResources.mobileNumberPlaceHolder"
                        (input)="triggerValidation('mobileNumber')"
                        [ngClass]="{'is-invalid': registerForm.get('mobileNumber')?.invalid && registerForm.get('mobileNumber')?.touched}" />
                    <div *ngIf="registerForm.get('mobileNumber')?.touched && registerForm.get('mobileNumber')?.invalid">
                        <small class="text-danger">
                            {{ getMobileErrorMessage() }}
                        </small>
                    </div>
                </div>
            </div>

            <div class="row mb-3" *ngIf="allowEmail">
                <div class="col-md-12">
                    <label for="email" class="form-label">
                        {{ finalResources.emailAddressLabel }} <span class="text-danger">*</span>
                    </label>
                    <input id="email" formControlName="email" type="email" class="form-control"
                        [placeholder]="finalResources.emailAddressPlaceHolder" />
                    <div *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.invalid">
                        <small class="text-danger">
                            {{ getEmailErrorMessage() }}
                        </small>
                    </div>
                </div>
            </div>

            <!-- Preferred Language -->
            <div class="row mb-3">
                <div class="col-md-12">
                    <label for="preferredLanguage" class="form-label">
                        {{ finalResources.preferredLanguageLabel }}
                    </label>
                    <select id="preferredLanguage" formControlName="preferredLanguage" class="form-control" [ngClass]="{'is-invalid': registerForm.get('preferredLanguage')?.invalid
                            && registerForm.get('preferredLanguage')?.touched}">
                        <option *ngFor="let lang of preferredLanguagesOptions" [value]="lang.code">
                            {{ lang.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div>
                <div class="form-check">
                    <input type="checkbox" formControlName="terms" class="form-check-input" id="terms"
                        style="width: 10px;" />
                    <label class="form-check-label" for="terms">
                        By checking this box, I confirm that I am at least 18 years of age, and that I accept all of the
                        <a [href]="TERMSOFUSEURL" target="_blank">Terms Of Use</a>
                        and our
                        <a [href]="PRIVACYPOLICYURL" target="_blank">Privacy Policy</a>.
                    </label>
                </div>
                <div *ngIf="registerForm.get('terms')?.touched && registerForm.get('terms')?.invalid">
                    <small class="text-danger">{{finalResources.termsAndConditionInvalidErrMsg}}</small>
                </div>
            </div>
            <div>
                <div class="form-check">
                    <input type="checkbox" formControlName="IsMarketingOptedIn" class="form-check-input" id="IsMarketingOptedIn"
                        style="width: 10px;" />
                    <label class="form-check-label" for="IsMarketingOptedIn">
                        {{finalResources.marketingOptedMsg}}
                        <br />
                        {{finalResources.marketingOptedMsgUnsubscribe}}
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <button type="submit" class="btn btn-primary"
                        [disabled]="registerForm.invalid">{{finalResources.registerBtnLabel}}</button>
                </div>
            </div>
        </form>
    </div>
</div>
